import TextInput from '@atoms/TextInput/TextInput';
import {
  IPersonalDetailsFormFields,
  IPersonalDetailsTextFields,
} from '@models/IPersonalDetailsFormFields';
import PhoneNumberInput from '@molecules/PhoneNumberInput/PhoneNumberInput';
import { emailRegex } from '@utility/constants/emailRegex';

const PersonalDetailsFormFields = ({
  firstName,
  lastName,
  email,
  phone,
  dialCode,
  emailValidationMessage,
  requiredMessage,
}: IPersonalDetailsFormFields & IPersonalDetailsTextFields) => (
  <>
    <div className="tw-col-span-2 md:tw-col-span-1">
      <TextInput
        id="firstName"
        className="tw-text-sm"
        label={firstName.label}
        placeholder={firstName.placeholder}
        registerOptions={{ required: requiredMessage }}
      />
    </div>
    <div className="tw-col-span-2 md:tw-col-span-1">
      <TextInput
        id="lastName"
        className="tw-text-sm"
        label={lastName.label}
        placeholder={lastName.placeholder}
        registerOptions={{ required: requiredMessage }}
      />
    </div>
    <div className="tw-col-span-2 md:tw-col-span-1">
      <TextInput
        id="email"
        className="tw-text-sm"
        label={email.label}
        placeholder={email.placeholder}
        registerOptions={{
          required: requiredMessage,
          pattern: {
            value: emailRegex,
            message: emailValidationMessage,
          },
        }}
      />
    </div>
    <div className="tw-col-span-2 md:tw-col-span-1">
      <PhoneNumberInput
        dialCode={{
          id: 'telephoneCountryCode',
          ...dialCode,
          options: dialCode.options.map((option) => ({
            label: option.label,
            id: option.value,
          })),
          preSelectedValue: dialCode.preSelectedValue ?? '',
        }}
        phoneNumber={{ id: 'telephoneNumber', ...phone }}
        requiredValidationMessage={requiredMessage}
      />
    </div>
  </>
);

export default PersonalDetailsFormFields;
